import React, { useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";
import TopNavbar from "@/components/layout/TopNavbar";
import Footer from "@/components/home/Footer";

const Eula = () => {
  const termlyRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Set the name attribute on the Termly embed div
    if (termlyRef.current) {
      termlyRef.current.setAttribute('name', 'termly-embed');
    }

    // Load Termly.io embed script
    const loadTermlyScript = () => {
      // Check if script is already loaded
      if (document.getElementById('termly-jssdk')) return;
      
      const script = document.createElement('script');
      script.id = 'termly-jssdk';
      script.src = 'https://app.termly.io/embed-policy.min.js';
      script.type = 'text/javascript';
      
      // Insert script into document head
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else {
        document.head.appendChild(script);
      }
    };

    loadTermlyScript();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>End User License Agreement - Hivetivity</title>
        <meta name="description" content="Hivetivity's End User License Agreement (EULA) for software usage terms" />
      </Helmet>
      
      <TopNavbar />
      
      <main className="pt-16">
        <div className="container mx-auto px-4 py-16">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl font-bold text-[#5a5a59] mb-8 text-center">End User License Agreement</h1>
            
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
              {/* Termly.io Embed */}
              <div ref={termlyRef} data-id="8425856d-0257-46d5-9fc4-b0491fc10ca8"></div>
              
              {/* Loading fallback */}
              <div id="termly-loading" className="text-center py-8 text-gray-500">
                <div className="animate-spin inline-block w-6 h-6 border-[3px] border-current border-t-transparent text-blue-600 rounded-full" role="status" aria-label="loading">
                  <span className="sr-only">Loading...</span>
                </div>
                <p className="mt-2">Loading End User License Agreement...</p>
              </div>
            </div>
            
            <div className="mt-8 text-center text-sm text-gray-500">
              <p>
                Questions about our EULA? Contact us at{' '}
                <a 
                  href="mailto:info@hivetivity.com" 
                  className="text-blue-600 hover:text-blue-800 underline"
                >
                  info@hivetivity.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default Eula; 